
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34134',
  depVersions: {
  "documents-public-ui": "static-1.34134",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34139",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1995",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5460",
  "hs-test-utils": "static-1.7876",
  "hub-http": "static-1.6085",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11310",
  "I18n": "static-7.1595",
  "jasmine-immutable": "static-1.2884",
  "jasmine-runner": "static-1.6337",
  "lodash": "static-1.3",
  "quartz": "static-1.6819",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16517",
  "reporting-data": "static-1.66808",
  "reporting-testing-lib": "static-1.8741",
  "reporting-visualizations": "static-1.58884",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4635",
  "webpack-env": "static-1.54",
  "atom": "static-1.4937",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2359",
  "classnames": "static-2.10",
  "cssUtils": "static-1.760",
  "customer-data-filters-ui": "static-1.39151",
  "customer-data-objects": "static-1.7520",
  "customer-data-property-utils": "static-1.7947",
  "data-fetching-client": "static-1.9544",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4396",
  "flux-actions": "static-1.321",
  "FormsCommonComponents": "static-1.85456",
  "FormUrlGenerator": "static-2.4588",
  "foundations-components": "static-1.7650",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11618",
  "icons": "static-2.635",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7026",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3722",
  "property-translator": "static-1.5276",
  "quartz-config": "static-1.597",
  "quartz-core": "static-1.6038",
  "quick-fetch": "static-1.3801",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5237",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8032",
  "reference-resolvers-lite": "static-1.7952",
  "report-customization-components": "static-1.12711",
  "reporting-enablement": "static-1.22328",
  "reporting-reports": "static-1.66486",
  "reporting-snowflake": "static-1.55426",
  "reporting-ui-components": "static-2.64079",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4511",
  "sales-content-partitioning": "static-1.8803",
  "SalesContentIndexUI": "static-3.9007",
  "sanitize": "static-1.4341",
  "sanitize-text": "static-1.8012",
  "self-service-api": "static-1.10109",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1620",
  "signup-constants": "static-1.18544",
  "signup-ui-lego-core": "static-1.20554",
  "signup-ui-url-generator": "static-2.7902",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4636",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10860",
  "ui-addon-i18n": "static-1.11013",
  "ui-addon-react-router-dom": "static-1.9412",
  "ui-addon-upgrades": "static-9.17760",
  "ui-asset-management-lib": "static-1.10806",
  "ui-images": "static-2.1120",
  "UIComponents": "static-3.8257",
  "usage-tracker": "static-1.7202",
  "usage-tracker-container": "static-1.7192",
  "usage-tracker-core": "static-1.7052",
  "usage-tracker-public": "static-1.7013",
  "viral-links-lib": "static-1.6907",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3293",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3096",
  "quartz-webpack": "static-1.3043",
  "ai-components-ui-library": "static-1.8555",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4708",
  "foundations-theming": "static-1.4279",
  "quartz-auth": "static-1.494",
  "ui-business-units-lib": "static-1.8900",
  "usage-tracker-session-replay": "static-1.4888",
  "foundations-theming-base": "static-1.3264",
  "HeadJS": "static-2.728",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2987",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4193",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7791",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3483",
  "persist-promise": "static-1.3575",
  "reporting-client-types": "static-1.2409",
  "foundations-components-legacy": "static-1.675",
  "hs-story-utils": "static-1.9293",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9645",
  "hubspotter-http": "static-1.4541",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7116",
  "crm-message-bus": "static-1.42569",
  "customer-data-filters-ui-msw-helpers": "static-1.21586",
  "customer-data-objects-ui-components": "static-1.12880",
  "customer-data-reference-ui-components": "static-1.13016",
  "customer-data-ui-utilities": "static-1.9691",
  "framework-builder-read-service-client": "static-1.3896",
  "framework-data-schema-quick-fetch": "static-1.6645",
  "framework-data-schema-resolvers": "static-1.6740",
  "inbound-db-properties-service-client": "static-1.3734",
  "multi-account-reference-resolvers": "static-1.844",
  "onboarding-tours": "static-1.16355",
  "reporting-datasets-permissions-lib": "static-1.13253",
  "ui-addon-teams": "static-1.21338",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67832",
  "customer-data-properties": "static-1.51002",
  "forms-ai-lib": "static-1.4102",
  "forms-utils-lib": "static-1.12302",
  "foundations-components-test-utils": "static-1.5133",
  "react-dnd-compat": "static-1.4487",
  "react-tinymce": "static-1.54814",
  "tinymce-config": "static-2.53940",
  "ui-gdpr-components": "static-1.10215",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3919",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1405",
  "ui-fonts": "static-1.572",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.813",
  "mobile-manifest-mixins": "static-1.503",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.484",
  "quartz-i18n": "static-1.494",
  "quartz-routing": "static-1.249",
  "quartz-test": "static-1.494",
  "quartz-tracking": "static-1.198",
  "batch-promise": "static-1.1418",
  "external-options-client-types": "static-1.4047",
  "react-colorpicker": "static-2.10078",
  "copilot-toolkit": "static-1.10712",
  "data-quality-ui-library": "static-1.12492",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6330",
  "reporting-action-components": "static-1.40836",
  "reporting-insights-lib": "static-1.1267",
  "reporting-plugins": "static-1.10065",
  "ui-addon-draggable-compat": "static-2.4121",
  "ui-addon-opt": "static-4.8251",
  "ui-shepherd-react": "static-3.10013",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24917",
  "hubspot-apollo-client": "static-1.4746",
  "chirp-fetch": "static-1.1750",
  "sales-templates-service-types-lib": "static-1.4055",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5595",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3968",
  "timezone-utils": "static-2.5111",
  "bender-build-tools": "static-1.3022",
  "chatspot-core": "static-1.20619",
  "bend-plugin-foundations-theming": "static-1.2762",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9643",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3686",
  "crm-pipelines-api-client-types": "static-1.4028",
  "multi-currency-client-types": "static-1.3578",
  "getting-started-shared-tasks": "static-1.18070",
  "growth-data-modal": "static-1.5226",
  "growth-onboarding-confetti": "static-1.2939",
  "growth-onboarding-next-action-utils": "static-1.1475",
  "navigation-components": "static-1.17500",
  "onboarding-tours-client": "static-1.4569",
  "onboarding-tours-utils": "static-1.421",
  "ui-shepherd-tracker": "static-1.7394",
  "ui-universal-auth": "static-1.8789",
  "user-context": "static-1.4967",
  "cms-field-types": "static-1.4676",
  "content-icons-ui": "static-1.2184",
  "integrations-lib": "static-1.15633",
  "calling-global-api": "static-1.63936",
  "calling-internal-common": "static-1.31167",
  "calling-lifecycle-internal": "static-1.65318",
  "calling-lifecycle-messages": "static-1.57612",
  "commerce-products-lib": "static-1.9032",
  "crm-links": "static-1.6136",
  "file-manager-components": "static-1.23125",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.554",
  "inbounddb-objects-service-types": "static-1.4111",
  "meetings-icalendar-utils-lib": "static-1.499",
  "object-builder-ui-client": "static-1.48231",
  "pipeline-validation-client-types": "static-1.3852",
  "property-value-citations": "static-1.1616",
  "pulse": "static-1.392",
  "smart-property-lib": "static-1.6202",
  "tiered-pricing": "static-1.935",
  "ui-addon-iframeable": "static-1.8914",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19589",
  "tinymce-themes": "static-1.55910",
  "data-token-picker": "static-1.16161",
  "hub-http-contrib": "static-1.2910",
  "interframe": "static-3.4630",
  "tinymce-data": "static-1.40025",
  "tinymce-plugins": "static-1.57054",
  "ui-addon-sales-email": "static-1.5080",
  "magpie-lib": "static-1.5461",
  "magpie-types": "static-1.4921",
  "simple-logging-lib": "static-1.2917",
  "content-assistance-lib": "static-1.7542",
  "dashboard-lib": "static-1.80908",
  "ExportDialog": "static-6.10256",
  "hubspot-prosemirror": "static-1.17802",
  "hubspot-prosemirror-plugins": "static-1.17794",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8560",
  "campaign-roi-lib": "static-1.8484",
  "feedback-loader": "static-1.29007",
  "apollo-link-hub-http": "static-2.4518",
  "hubspot-apollo-cache": "static-1.205",
  "growth-monetization-service-types": "static-1.4366",
  "nav-client-types": "static-1.2224",
  "purchase-motions-api": "static-1.5598",
  "trials-service-types": "static-1.3767",
  "growth-onboarding-next-action-components": "static-1.1503",
  "user-context-client": "static-1.4480",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.592",
  "unified-auth-core-lib": "static-1.584",
  "getting-started-shared-tasks-store": "static-1.17188",
  "integrations-error-boundary-lib": "static-1.13048",
  "integrations-tracking-lib": "static-1.5457",
  "native-integrations-shared-strings": "static-1.7654",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10241",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31173",
  "shared-worker-versioning": "static-1.10906",
  "calling-usage-tracker": "static-1.6408",
  "voice-sms-access-library": "static-1.443",
  "customer-data-tracking": "static-1.6749",
  "commerce-permissions": "static-1.630",
  "products-iframe-lib": "static-1.7520",
  "products-ui-components-shared-msw-handlers": "static-1.10027",
  "location-customization-utils-lib": "static-1.8774",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4021",
  "video-components-external": "static-1.10787",
  "video-data-lib": "static-1.34445",
  "directed-graph": "static-1.806",
  "event-emitter": "static-1.814",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5416",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9728",
  "fsm": "static-1.3597",
  "policy-lib": "static-1.6645",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9791",
  "navigation-messaging": "static-1.6827",
  "FileManagerLib": "static-1.38765",
  "NamespacedHubStyle": "static-2.8958",
  "FileManagerCore": "static-1.38624",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12173",
  "layout-dnd-utils": "static-1.11148",
  "react-codemirror": "static-1.10493",
  "ui-addon-emoji-picker": "static-1.9754",
  "ui-brand-identity-lib": "static-1.14375",
  "ui-addon-video-player": "static-1.8563",
  "ui-coaching-tips": "static-1.28123",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8425",
  "payment-link-components": "static-1.23116",
  "EmailSignatureEditor": "static-1.24036",
  "eligibility-engine-service-types": "static-1.3048",
  "universal-page-editor-lib": "static-1.2868",
  "calling-orchestration-schema": "static-1.35220",
  "sales-views-client-types": "static-1.4135",
  "crm-record-cards-service-types": "static-1.3505",
  "content-media-composition-data-lib": "static-1.11729",
  "content-media-compositions": "static-2.15736",
  "media-bridge-lib": "static-1.18683",
  "trellis-story-utils": "static-1.4387",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5706",
  "FileManagerImages": "static-1.36276",
  "video-components": "static-1.12790",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4398",
  "video-embed": "static-1.35279",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67907",
  "layout-data-lib": "static-1.9473",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6448",
  "commerce-tours-lib": "static-1.5827",
  "growth-onboarding-reliability": "static-1.4953",
  "sales-checkout-service-client": "static-1.3535",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21427",
  "sales-email-signature-service-client": "static-1.3710",
  "social-insights-client-types": "static-1.21591",
  "outpost": "static-1.4066",
  "advanced-menus-core": "static-1.14912",
  "advanced-menus-lib": "static-1.11880",
  "ui-memberships-settings-lib": "static-1.33630",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14911",
  "simple-menus-lib": "static-1.16428"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34134",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34139",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1995",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5460",
  "hs-test-utils": "/hs-test-utils/static-1.7876",
  "hub-http": "/hub-http/static-1.6085",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11310",
  "I18n": "/I18n/static-7.1595",
  "jasmine-immutable": "/jasmine-immutable/static-1.2884",
  "jasmine-runner": "/jasmine-runner/static-1.6337",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6819",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16517",
  "reporting-data": "/reporting-data/static-1.66808",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8741",
  "reporting-visualizations": "/reporting-visualizations/static-1.58884",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4635",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4937",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2359",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.760",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39151",
  "customer-data-objects": "/customer-data-objects/static-1.7520",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7947",
  "data-fetching-client": "/data-fetching-client/static-1.9544",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4396",
  "flux-actions": "/flux-actions/static-1.321",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85456",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4588",
  "foundations-components": "/foundations-components/static-1.7650",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11618",
  "icons": "/icons/static-2.635",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7026",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3722",
  "property-translator": "/property-translator/static-1.5276",
  "quartz-config": "/quartz-config/static-1.597",
  "quartz-core": "/quartz-core/static-1.6038",
  "quick-fetch": "/quick-fetch/static-1.3801",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5237",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8032",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7952",
  "report-customization-components": "/report-customization-components/static-1.12711",
  "reporting-enablement": "/reporting-enablement/static-1.22328",
  "reporting-reports": "/reporting-reports/static-1.66486",
  "reporting-snowflake": "/reporting-snowflake/static-1.55426",
  "reporting-ui-components": "/reporting-ui-components/static-2.64079",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4511",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8803",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9007",
  "sanitize": "/sanitize/static-1.4341",
  "sanitize-text": "/sanitize-text/static-1.8012",
  "self-service-api": "/self-service-api/static-1.10109",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1620",
  "signup-constants": "/signup-constants/static-1.18544",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20554",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7902",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4636",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10860",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11013",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9412",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17760",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10806",
  "ui-images": "/ui-images/static-2.1120",
  "UIComponents": "/UIComponents/static-3.8257",
  "usage-tracker": "/usage-tracker/static-1.7202",
  "usage-tracker-container": "/usage-tracker-container/static-1.7192",
  "usage-tracker-core": "/usage-tracker-core/static-1.7052",
  "usage-tracker-public": "/usage-tracker-public/static-1.7013",
  "viral-links-lib": "/viral-links-lib/static-1.6907",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3293",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3096",
  "quartz-webpack": "/quartz-webpack/static-1.3043",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8555",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4708",
  "foundations-theming": "/foundations-theming/static-1.4279",
  "quartz-auth": "/quartz-auth/static-1.494",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8900",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4888",
  "foundations-theming-base": "/foundations-theming-base/static-1.3264",
  "HeadJS": "/HeadJS/static-2.728",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2987",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4193",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7791",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3483",
  "persist-promise": "/persist-promise/static-1.3575",
  "reporting-client-types": "/reporting-client-types/static-1.2409",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.675",
  "hs-story-utils": "/hs-story-utils/static-1.9293",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9645",
  "hubspotter-http": "/hubspotter-http/static-1.4541",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7116",
  "crm-message-bus": "/crm-message-bus/static-1.42569",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21586",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12880",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13016",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9691",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3896",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6645",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6740",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3734",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.844",
  "onboarding-tours": "/onboarding-tours/static-1.16355",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13253",
  "ui-addon-teams": "/ui-addon-teams/static-1.21338",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67832",
  "customer-data-properties": "/customer-data-properties/static-1.51002",
  "forms-ai-lib": "/forms-ai-lib/static-1.4102",
  "forms-utils-lib": "/forms-utils-lib/static-1.12302",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5133",
  "react-dnd-compat": "/react-dnd-compat/static-1.4487",
  "react-tinymce": "/react-tinymce/static-1.54814",
  "tinymce-config": "/tinymce-config/static-2.53940",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10215",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3919",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1405",
  "ui-fonts": "/ui-fonts/static-1.572",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.813",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.503",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.484",
  "quartz-i18n": "/quartz-i18n/static-1.494",
  "quartz-routing": "/quartz-routing/static-1.249",
  "quartz-test": "/quartz-test/static-1.494",
  "quartz-tracking": "/quartz-tracking/static-1.198",
  "batch-promise": "/batch-promise/static-1.1418",
  "external-options-client-types": "/external-options-client-types/static-1.4047",
  "react-colorpicker": "/react-colorpicker/static-2.10078",
  "copilot-toolkit": "/copilot-toolkit/static-1.10712",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12492",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6330",
  "reporting-action-components": "/reporting-action-components/static-1.40836",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1267",
  "reporting-plugins": "/reporting-plugins/static-1.10065",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4121",
  "ui-addon-opt": "/ui-addon-opt/static-4.8251",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10013",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24917",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4746",
  "chirp-fetch": "/chirp-fetch/static-1.1750",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4055",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5595",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3968",
  "timezone-utils": "/timezone-utils/static-2.5111",
  "bender-build-tools": "/bender-build-tools/static-1.3022",
  "chatspot-core": "/chatspot-core/static-1.20619",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2762",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9643",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3686",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4028",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3578",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18070",
  "growth-data-modal": "/growth-data-modal/static-1.5226",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2939",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1475",
  "navigation-components": "/navigation-components/static-1.17500",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4569",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.421",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7394",
  "ui-universal-auth": "/ui-universal-auth/static-1.8789",
  "user-context": "/user-context/static-1.4967",
  "cms-field-types": "/cms-field-types/static-1.4676",
  "content-icons-ui": "/content-icons-ui/static-1.2184",
  "integrations-lib": "/integrations-lib/static-1.15633",
  "calling-global-api": "/calling-global-api/static-1.63936",
  "calling-internal-common": "/calling-internal-common/static-1.31167",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65318",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57612",
  "commerce-products-lib": "/commerce-products-lib/static-1.9032",
  "crm-links": "/crm-links/static-1.6136",
  "file-manager-components": "/file-manager-components/static-1.23125",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.554",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4111",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.499",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48231",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3852",
  "property-value-citations": "/property-value-citations/static-1.1616",
  "pulse": "/pulse/static-1.392",
  "smart-property-lib": "/smart-property-lib/static-1.6202",
  "tiered-pricing": "/tiered-pricing/static-1.935",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8914",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19589",
  "tinymce-themes": "/tinymce-themes/static-1.55910",
  "data-token-picker": "/data-token-picker/static-1.16161",
  "hub-http-contrib": "/hub-http-contrib/static-1.2910",
  "interframe": "/interframe/static-3.4630",
  "tinymce-data": "/tinymce-data/static-1.40025",
  "tinymce-plugins": "/tinymce-plugins/static-1.57054",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5080",
  "magpie-lib": "/magpie-lib/static-1.5461",
  "magpie-types": "/magpie-types/static-1.4921",
  "simple-logging-lib": "/simple-logging-lib/static-1.2917",
  "content-assistance-lib": "/content-assistance-lib/static-1.7542",
  "dashboard-lib": "/dashboard-lib/static-1.80908",
  "ExportDialog": "/ExportDialog/static-6.10256",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17802",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17794",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8560",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8484",
  "feedback-loader": "/feedback-loader/static-1.29007",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4518",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.205",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4366",
  "nav-client-types": "/nav-client-types/static-1.2224",
  "purchase-motions-api": "/purchase-motions-api/static-1.5598",
  "trials-service-types": "/trials-service-types/static-1.3767",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1503",
  "user-context-client": "/user-context-client/static-1.4480",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.592",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.584",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17188",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13048",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5457",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7654",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10241",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31173",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10906",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6408",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.443",
  "customer-data-tracking": "/customer-data-tracking/static-1.6749",
  "commerce-permissions": "/commerce-permissions/static-1.630",
  "products-iframe-lib": "/products-iframe-lib/static-1.7520",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10027",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8774",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4021",
  "video-components-external": "/video-components-external/static-1.10787",
  "video-data-lib": "/video-data-lib/static-1.34445",
  "directed-graph": "/directed-graph/static-1.806",
  "event-emitter": "/event-emitter/static-1.814",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5416",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9728",
  "fsm": "/fsm/static-1.3597",
  "policy-lib": "/policy-lib/static-1.6645",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9791",
  "navigation-messaging": "/navigation-messaging/static-1.6827",
  "FileManagerLib": "/FileManagerLib/static-1.38765",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8958",
  "FileManagerCore": "/FileManagerCore/static-1.38624",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12173",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11148",
  "react-codemirror": "/react-codemirror/static-1.10493",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9754",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14375",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8563",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28123",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8425",
  "payment-link-components": "/payment-link-components/static-1.23116",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24036",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3048",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2868",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35220",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3505",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11729",
  "content-media-compositions": "/content-media-compositions/static-2.15736",
  "media-bridge-lib": "/media-bridge-lib/static-1.18683",
  "trellis-story-utils": "/trellis-story-utils/static-1.4387",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5706",
  "FileManagerImages": "/FileManagerImages/static-1.36276",
  "video-components": "/video-components/static-1.12790",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4398",
  "video-embed": "/video-embed/static-1.35279",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67907",
  "layout-data-lib": "/layout-data-lib/static-1.9473",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6448",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5827",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4953",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3535",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21427",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3710",
  "social-insights-client-types": "/social-insights-client-types/static-1.21591",
  "outpost": "/outpost/static-1.4066",
  "advanced-menus-core": "/advanced-menus-core/static-1.14912",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11880",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33630",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14911",
  "simple-menus-lib": "/simple-menus-lib/static-1.16428"
}
};
